var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('document', 'documentElement');



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/html.js
// module id = 1169
// module chunks = 0